'use client'

import React from "react";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";
import {PortableTextBlock} from "sanity";

export default function InfoBox({
  title,
  text,
  color = "#D9F9B9",
  className = "",
}: {
  title?: string;
  text?: PortableTextBlock[];
  color?: string;
  className?: string;
}){
  return (
    <div
      className={cn(
        "w-full px-[1.5rem] pt-[1.5rem] pb-[1.25rem]",
        className
      )}
      style={{
        borderLeft: `2px solid ${color}`,
        backgroundColor: `color-mix(in srgb, ${color} 5%, transparent)`,
      }}
    >
      <p
        className={cn(
          "mb-0 text-[1.75rem] uppercase leading-none",
          text && "mb-[1rem] font-geistmono"
        )}
        style={{
          color: color,
        }}
      >
        {title ?? "Outcome"}
      </p>

      {text && (
        <div
          className="richtext richtext-start prose-p:text-[2rem] prose-p:leading-[1.3] prose-p:[color:color-mix(in_srgb,var(--text-color)_60%,transparent)]"
          style={{
            '--text-color': color
          } as React.CSSProperties}
        >
          <PortableText
            value={text}
            components={richTextComponent}
          />
        </div>
      )}
    </div>
  );
}